import { Box, Container, Stack } from '@mui/material'
import Nav from './Nav'

export default () => {
  return (
    // Temporary change until admin modernization
    // <Box sx={{ background: '#DDE3EA' }}>
    //   <Container maxWidth="xl">
    //     <Nav />
    //   </Container>
    // </Box>

    <Stack
      direction="row"
      justifyContent="center"
      sx={{ background: '#DDE3EA' }}
    >
      <Nav />
    </Stack>
  )
}
